module.exports = __webpack_public_path__ + "img/DE02986.adee9f38.png";